module.exports = __webpack_public_path__ + "img/goqus2.f32f1464.png";